import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { RESPOND_SHARING } from 'commons/constants/permissions'

const ManagerApprovalPage = lazy(() => import('pages/ManagerApproval'))

export default [
  {
    path: '/managerApproval',
    component: ManagerApprovalPage,
    permissions: RESPOND_SHARING,
  },
] as Route[]
